export const basicOptions = [
  { label: "Option 1", value: 1 },
  { label: "Option 2", value: 2 },
  { label: "Option 3", value: 3 }
];

export const compliments = [
  "AREE",
  "PACCHETTI",
  "UTENTI",
  "SERVIZI"

].map((label) => ({ label, value: label.toLowerCase() }));
